import { render } from "./HowToPlay.vue?vue&type=template&id=345ffd7c&scoped=true"
import script from "./HowToPlay.vue?vue&type=script&lang=js"
export * from "./HowToPlay.vue?vue&type=script&lang=js"

import "./HowToPlay.vue?vue&type=style&index=0&id=345ffd7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345ffd7c"]])

export default __exports__